// overlayKit/palette.tsx — Palette via React Context. No production-specific defaults.
// Each production wraps its tree in <PaletteProvider value={MY_PALETTE}>; components
// inside use useColor("primary") / useColor("secondary") / useColor("neutral") etc.
import React from "react";

export type Palette = Record<string, string>;

const PaletteContext = React.createContext<Palette | null>(null);

export const PaletteProvider: React.FC<{ value: Palette; children: React.ReactNode }> = ({
  value,
  children,
}) => <PaletteContext.Provider value={value}>{children}</PaletteContext.Provider>;

/** Read the active palette dictionary. Throws if no provider is mounted. */
export const usePalette = (): Palette => {
  const p = React.useContext(PaletteContext);
  if (!p) {
    throw new Error(
      "usePalette: no <PaletteProvider> mounted. Wrap your composition tree in one."
    );
  }
  return p;
};

/** Resolve ONE token to its hex. Convenience for components that only need a single color.
 *  For multiple colors (e.g. resolving a list inside a .map), call `usePalette()` at the top
 *  of the component and resolve via the returned object — React hook rules forbid useColor in loops. */
export const useColor = (token: string): string => {
  const p = usePalette();
  const v = p[token];
  if (!v) {
    throw new Error(
      `useColor: unknown palette token ${JSON.stringify(token)} — known: ${Object.keys(p).join(", ")}`
    );
  }
  return v;
};

/** Pure helper (NOT a hook) — resolves a token given an already-fetched palette dictionary. */
export const resolveColor = (palette: Palette, token: string): string => {
  const v = palette[token];
  if (!v) {
    throw new Error(
      `resolveColor: unknown palette token ${JSON.stringify(token)} — known: ${Object.keys(palette).join(", ")}`
    );
  }
  return v;
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
